<template>
  <div class="asset-approval">
    <van-nav-bar title="资产审批" />

    <p class="asset-approval__tip">请选择资产类型，进入对应审批页面</p>

    <van-cell-group>
      <van-cell
        title="IT资产审批"
        value="打开"
        is-link
        :url="itApprovalUrl"
      />
      <van-cell
        title="行政资产审批"
        value="打开"
        is-link
        :url="adminApprovalUrl"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { NavBar, Cell, CellGroup } from 'vant'
import 'vant/lib/index.css'

export default {
  name: 'AssetApproval',
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      itApprovalUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww0f3efc2873ad11c3&redirect_uri=paas.aukeyis.com/login/?auth_type=3&response_type=code&scope=snsapi_privateinfo&agentid=1000246&state=ww0f3efc2873ad11c3,/o/workbench/#/open/fixed?asset_code=IT#wechat_redirect',
      adminApprovalUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww0f3efc2873ad11c3&redirect_uri=paas.aukeyis.com/login/?auth_type=3&response_type=code&scope=snsapi_privateinfo&agentid=1000246&state=ww0f3efc2873ad11c3,/o/workbench/#/open/fixed?asset_code=%E8%A1%8C%E6%94%BF#wechat_redirect'
    }
  }
}
</script>

<style scoped>
.asset-approval {
  min-height: 100vh;
  background: #f7f8fa;
}

.asset-approval__tip {
  margin: 0;
  padding: 20px 16px 12px;
  color: #646566;
  font-size: 14px;
  line-height: 1.6;
}

.asset-approval .van-cell {
  padding: 18px 16px;
}
</style>
